export class ongoingCallIvrService {
    constructor(params) {
        this.SingletonWebSocket = params.SingletonWebSocket;
        this.SingletonSharedData = params.SingletonSharedData;
        this.StateRule = params.StateRule;
    }
    getIVRList() {
        const action = "GetIVRList";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action: "CallAction",
                callAction: action
            }
            this.SingletonWebSocket.send(message);
        }
    }
    idleStart(IVRId) {
        const action = "IdleStart";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action: action,
                IVRId: IVRId
            }
            this.SingletonWebSocket.send(message);
        }
    }
}


// WEBPACK FOOTER //
// ./src/Services/ongoingCallIvrService.js